// extracted by mini-css-extract-plugin
module.exports = {"titleDetail":"yP","header":"yQ","headerUnderTrailer":"yR","leftHeader":"yS","buttonsWrapper":"yT","rightHeader":"yU","rentalBadge":"yV","rentalNotesFrame":"yW"};